// extracted by mini-css-extract-plugin
export default {"chip":"appointmentTags_chip__4vtqC","chipEmoji":"appointmentTags_chipEmoji__ecSUb","chipName":"appointmentTags_chipName__aFMDq"};